import {useRef} from "react";
import {useTableTopOverlayBounds} from "./TableTopOverlayBounds.tsx";
import {useOverlayPanelHeight} from "./useOverlayPanelHeight.ts";
import {calculatePopoverPosition, isPopoverOffscreen, POPOVER_MARGIN,
    type OverlaySize, type PopoverAnchor} from "./MapPopoverPosition.ts";

export function useMapPopoverLayout({anchor, viewport, width, gap = 24}: {
    anchor: PopoverAnchor; viewport: OverlaySize; width: number; gap?: number;
}) {
    const {panelBounds, viewport: mapViewport} = useTableTopOverlayBounds(viewport);
    const panelRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const height = useOverlayPanelHeight(panelRef, contentRef);
    const position = calculatePopoverPosition(anchor, panelBounds, {
        width, height: height > 0 ? height : Math.max(0, panelBounds.height - 2 * POPOVER_MARGIN),
    }, gap);
    const offscreen = isPopoverOffscreen(anchor, mapViewport);
    return {panelRef, contentRef, style: {...position,
        visibility: offscreen ? "hidden" as const : "visible" as const,
        pointerEvents: offscreen ? "none" as const : "auto" as const}};
}
